import configuration from '../../constants/Configuration';
import shapeTypes from '../../constants/ShapeConstants';
import drawingUtils from '../utils/DrawingUtils';
import {updateImageSize, updateImageSizeWhenChangeMood, updateShapePosition} from '../../actions/CurrentSlideActions';
import properties from '../../constants/Properties';
import platformDetection from './PlatformDetection';
import storeManager from '../../store/StoreManager';
import videoUtils from './VideoUtils';

const thumbnailGenerator = {
    canvasWidth: undefined,
    canvasRealWidth: undefined,
    shapes: undefined,
    currentIndex: 0,
    context: undefined,
    loadCurrentAsset: false,
    canvas: undefined,
    thumbsList: [],
    storeProductionThumbnailHandler: undefined,
    isProductionThumb: false,
    productionThumbKey: undefined,
    mapIds: [],
    checkImageOriginalSize: true,

    /************************** Production thumb drawing ****************************************/
    getFirstSlideModel() {
        const state = storeManager.getState();
        const slides = state.production.slides;

        return slides[0];
    },
    extractId(link) {
        var index = link.indexOf('file/ci/');
        var index2 = link.indexOf('/aaa');
        var id = -1;

        if (index2 < 0)
            index2 = link.indexOf('/img');

        if (index2 < 0)
            index2 = link.indexOf('/audio');

        if (index > 0 && index2 > 0)
            id = link.substring(index + 8, index2);

        return id;
    },
    getCorrectMediaSource(href) {
        var id = this.extractId(href);

        if (id != -1 && this.mapIds[id])
            return this.mapIds[id];
        else
            return '';
    },
    checkShape(shape) {
        var href = '';
        var id = -1;

          if (shape.type == shapeTypes.BACKGROUND || shape.type == shapeTypes.IMAGE || shape.type == shapeTypes.CHARACTER)
              href = shape.xlinkHref;

          if (href && href.length > 0)
              id = this.extractId(href);

          return id;
    },
    getMyMediaFilesIds(slideModel) {
        var shapes = slideModel.content;
        var ids = [];
        var id;
        var i, j;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].type == shapeTypes.GROUP) {
                var group = shapes[i];

                for (j=0; j<group.shapes.length; j++) {
                    var shape = group.shapes[j];

                    id = this.checkShape(shape);

                    if (id != -1)
                        ids.push(id);
                }
            } else {
                id = this.checkShape(shapes[i]);

                if (id != -1)
                    ids.push(id);
            }
        }

        return ids;
    },
    getProductionThumb(callBackFunction, productionThumbKey) {
        this.storeProductionThumbnailHandler = callBackFunction;
        this.productionThumbKey = productionThumbKey;

        var firstSlideThumb = document.createElement('canvas');
        firstSlideThumb.width = configuration.SCREENSHOT_WIDTH;
        firstSlideThumb.height = configuration.SCREENSHOT_WIDTH * 9/16;

        this.isProductionThumb = true;

        var firstSlideModel = this.getFirstSlideModel();
        this.drawThumbnail(firstSlideThumb, firstSlideModel, false);
    },
    productionThumbReady() {
        this.isProductionThumb = false;

        if (this.storeProductionThumbnailHandler)
            this.storeProductionThumbnailHandler(this.canvas, this.productionThumbKey);
    },

    /************************** Normal thumb drawing ****************************************/
    drawThumbnail (canvas, slideModel, updateThumbsList = true) {
        if (!canvas || !slideModel || !slideModel.content)
            return;

        if (updateThumbsList == true) {
            this.thumbsList.push({canvas, slideModel});

            if (this.thumbsList.length > 1) // there are at least 2 items in queue
                return;
        }

        this.canvas = canvas;
        this.context = canvas.getContext('2d');
        this.canvasRealWidth = canvas.width;
        this.canvasWidth = this.isProductionThumb ? configuration.SCREENSHOT_WIDTH : properties.SLIDE_ITEM_WIDTH;
        this.shapes = this.getAllShapes(slideModel.content);
        this.currentIndex = 0;
        this.loadCurrentAsset = false;

        this.resetTransform();
        //this.context.clearRect(0, 0, canvas.width, canvas.height);

        this.parseShapes();
    },
    getAllShapes(shapes) {
        var allShapes = [];
        var i, j;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].type == shapeTypes.GROUP) {
                var group = shapes[i];

                for (j=0; j<group.shapes.length; j++) {
                    var shape = Object.assign({}, group.shapes[j]);

                    shape.x = shape.x + group.x;
                    shape.y = shape.y + group.y;

                    allShapes.push(shape);
                }
            } else {
                allShapes.push(shapes[i]);
            }
        }

        return allShapes;
    },
    resetTransform() {
        this.context.closePath();
        this.context.setTransform(1, 0, 0, 1, 0, 0);
    },
    transformToLocalCoordinates(value) {
        const scale = this.canvasWidth / configuration.CANVAS_WIDTH;

        return value * scale;
    },
    degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    },
    transformRGBtoRGBA(color, opacity) {
        const r = parseInt(color.substr(1, 2), 16);
        const g = parseInt(color.substr(3, 2), 16);
        const b = parseInt(color.substr(5, 2), 16);

        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    },
    parseShapes() {
        if (this.shapes == undefined || this.shapes.length < 0)
            return;

        const shapes = this.shapes;
        var shape;
        var i = this.currentIndex;

        for (i; i<shapes.length; i++) {
            shape = shapes[i];

            this.resetTransform();

            if (this.loadCurrentAsset == true)
                return;

            switch(shape.type) {
                case shapeTypes.BACKGROUND : {
                    this.drawBackground(shape);
                    break;
                }
                case shapeTypes.VIDEO : {
                    this.drawVideoShape(shape);
                    break;
                }

                case shapeTypes.TRIANGLE:
                case shapeTypes.STAR:
                case shapeTypes.HEART:
                case shapeTypes.RECTANGLE:
                case shapeTypes.ELLIPSE: {
                    this.drawRectangularShape(shape);
                    this.currentIndex = this.currentIndex + 1;
                    break;
                }

                case shapeTypes.IMAGE:
                case shapeTypes.CHARACTER: {
                    this.drawImage(shape);
                    break;
                }

                case shapeTypes.CURVE:
                case shapeTypes.LINE: {
                    this.drawLineCurve(shape);
                    this.currentIndex = this.currentIndex + 1;
                    break;
                }

                case shapeTypes.FREEHAND: {
                    this.drawFreehand(shape);
                    this.currentIndex = this.currentIndex + 1;
                    break;
                }

                case shapeTypes.TEXTBOX:
                case shapeTypes.TEXTBOXSIMPLE:
                case shapeTypes.SPEAK_BUBBLE:
                case shapeTypes.COMPLEX_SPEAK_BUBBLE:
                case shapeTypes.SCREAM_BUBBLE:
                case shapeTypes.THOUGHT_BUBBLE: {
                    this.drawText(shape);
                    this.currentIndex = this.currentIndex + 1;
                    break;
                }
            }
        }

        if (this.isProductionThumb) {
            if (this.currentIndex >= shapes.length)
                this.productionThumbReady();
        } else {
            if (i >= shapes.length - 1) {
                // this.completeCanvas();

                if (this.thumbsList.length > 0)
                    this.thumbsList.shift();

                if (this.thumbsList.length > 0) {
                    const object = this.thumbsList[0];

                    //this.drawThumbnail(object.canvas, object.slideModel, false);
                    setTimeout(this.drawThumbnail.bind(this), 300, object.canvas, object.slideModel, false);
                }
            }
        }
    },
    completeCanvas() {
        if (this.canvasRealWidth > this.canvasWidth) {
            var steps = Math.floor(this.canvasRealWidth / this.canvasWidth);
            var i;

            if (steps > 0) {
                var clone = this.cloneCanvas(this.canvas);
                for (i = 0; i < steps; i++) {
                    this.context.drawImage(clone, (i + 1) * this.canvasWidth, 0);
                }
            }
        }
    },
    cloneCanvas(oldCanvas) {
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        newCanvas.width = this.canvasWidth;
        newCanvas.height = oldCanvas.height;

        context.drawImage(oldCanvas, 0, 0);

        return newCanvas;
    },
    drawBackground(shape) {
        const width = this.canvasWidth;
        const context = this.context;
        const self = this;
        var mediaSource;

        context.beginPath();

        if (shape.xlinkHref == undefined || shape.xlinkHref == '') {
            context.rect(0, 0, width, width * 9 / 16);

            if (shape.fillOpacity > 0) {
                context.fillStyle = shape.fill;
                context.fill();
            }

            if (shape.strokeOpacity > 0) {
                context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
                context.strokeStyle = shape.stroke;
                context.stroke();
            }

            this.currentIndex = this.currentIndex + 1;
        } else {
            if (shape.isVideo) {
                var video = document.createElement('video');

                if (shape.inPoint > 0)
                    video.currentTime = shape.inPoint;
                else
                    video.currentTime = 0.1;

                video.addEventListener('durationchange', function () {
                    var time = 1000;

                    if (platformDetection.isEdge() || platformDetection.isChromeBook())
                        time = 2 * time;

                    setTimeout(function() {
                        self.resetTransform();
                        context.drawImage(this, 0, 0, width, width * 9 / 16);

                        self.loadCurrentAsset = false;

                        self.currentIndex = self.currentIndex + 1;
                        self.parseShapes();
                    }.bind(this), time);
                });

                video.addEventListener('error', function () {
                    self.loadCurrentAsset = false;
                    self.currentIndex = self.currentIndex + 1;

                    self.parseShapes();
                });

                this.loadCurrentAsset = true;

                if (!configuration.LOAD_LOCAL && this.isProductionThumb) {
                    video.setAttribute('crossOrigin', 'anonymous');

                    mediaSource = this.getCorrectMediaSource(shape.xlinkHref);

                    if (mediaSource.length > 0)
                        video.src = videoUtils.checkCacheBreaker(mediaSource);
                    else
                        video.src = this.checkBucket(videoUtils.checkCacheBreaker(shape.xlinkHref));
                } else
                    video.src = videoUtils.checkCacheBreaker(shape.xlinkHref);

                video.load();
            } else {
                // load image from data url
                var imageObj = new Image();

                imageObj.onload = function () {
                    self.resetTransform();

                    if (shape.hotSpot != undefined && shape.hotSpot != '') {
                        var hotspot = shape.hotSpot;
                        var scale = configuration.CANVAS_WIDTH / hotspot.width;
                        var scaledWidth = width * scale;

                        context.drawImage(this, -self.transformToLocalCoordinates(hotspot.x) * scale, -self.transformToLocalCoordinates(hotspot.y) * scale, scaledWidth, scaledWidth * 9 / 16);
                    } else {
                        context.drawImage(this, 0, 0, width, width * 9 / 16);
                    }

                    self.loadCurrentAsset = false;

                    self.currentIndex = self.currentIndex + 1;
                    self.parseShapes();
                };

                imageObj.onerror = function () {
                    self.loadCurrentAsset = false;
                    self.currentIndex = self.currentIndex + 1;
                    console.log('ErrorLoadinBackground ***');

                    self.parseShapes();
                };

                this.loadCurrentAsset = true;

                if (!configuration.LOAD_LOCAL && this.isProductionThumb) {
                    imageObj.setAttribute('crossOrigin', 'anonymous');

                    mediaSource = this.getCorrectMediaSource(shape.xlinkHref);

                    if (mediaSource.length > 0)
                        imageObj.src = videoUtils.checkCacheBreaker(mediaSource);
                    else
                        imageObj.src = this.checkBucket(videoUtils.checkCacheBreaker(shape.xlinkHref));
                } else {
                    imageObj.src = videoUtils.checkCacheBreaker(shape.xlinkHref);
                }
            }
        }
    },
    drawVideoShape(shape) {
        const context = this.context;
        const self = this;
        let mediaSource;

        this.resetTransform();
        context.beginPath();

        let video = document.createElement('video');

        if (shape.inPoint > 0)
            video.currentTime = shape.inPoint;
        else
            video.currentTime = 0.1;

        video.addEventListener('durationchange', function () {
            const shapeCenterX = self.transformToLocalCoordinates(shape.x + shape.width / 2);
            const shapeCenterY = self.transformToLocalCoordinates(shape.y + shape.height / 2);
            const width = self.transformToLocalCoordinates(shape.width);
            const height = self.transformToLocalCoordinates(shape.height);
            let time = 1000;

            if (platformDetection.isEdge() || platformDetection.isChromeBook())
                time = 2 * time;

            setTimeout(function () {
                self.resetTransform();
                context.drawImage(this, shapeCenterX - width / 2, shapeCenterY - height / 2, width, height);

                self.loadCurrentAsset = false;
                self.currentIndex = self.currentIndex + 1;
                self.parseShapes();
            }.bind(this), time);
        });

        video.addEventListener('error', function () {
            self.loadCurrentAsset = false;
            self.currentIndex = self.currentIndex + 1;

            self.parseShapes();
        });

        this.loadCurrentAsset = true;

        if (!configuration.LOAD_LOCAL && this.isProductionThumb) {
            video.setAttribute('crossOrigin', 'anonymous');

            mediaSource = this.getCorrectMediaSource(shape.xlinkHref);

            if (mediaSource.length > 0)
                video.src = videoUtils.checkCacheBreaker(mediaSource);
            else
                video.src = this.checkBucket(videoUtils.checkCacheBreaker(shape.xlinkHref));
        } else
            video.src = videoUtils.checkCacheBreaker(shape.xlinkHref);

        video.load();
    },
    checkBucket(url) {
        if (url.indexOf('s3-eu-west-1.amazonaws.com/creaza-cartoonist-svg') != -1) // for the svgs ... old url
            url = url.replace('s3-eu-west-1.amazonaws.com/creaza-cartoonist-svg', 'd9e59cbjty4wx.cloudfront.net');

        if (url.indexOf('creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com') != -1) // for the svgs
            url = url.replace('creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com', 'd9e59cbjty4wx.cloudfront.net');

        if (url.indexOf('d3b76ijxom7qfl.cloudfront.net') != -1) // for the library videos
            url = url.replace('d3b76ijxom7qfl.cloudfront.net', 'creaza-clipart.s3.amazonaws.com');

        return url;
    },
    drawRectangularShape(shape) {
        const context = this.context;
        const shapeCenterX = this.transformToLocalCoordinates(shape.x + shape.width / 2);
        const shapeCenterY = this.transformToLocalCoordinates(shape.y + shape.height / 2);
        const width = this.transformToLocalCoordinates(shape.width);
        const height = this.transformToLocalCoordinates(shape.height);

        context.beginPath();
        context.translate(shapeCenterX, shapeCenterY);

        if (shape.rotation > 0) {
            context.rotate(this.degreesToRadians(shape.rotation));
        }

        switch(shape.type) {
            case shapeTypes.RECTANGLE: {
                context.rect(- width/2, - height/2, width, height);
                break;
            }
            case shapeTypes.ELLIPSE: {
                if (CanvasRenderingContext2D.prototype.ellipse != undefined)
                    context.ellipse(0, 0, width/2, height/2, 0, 0, 2 * Math.PI);
                break;
            }
            case shapeTypes.TRIANGLE: {
                var pointX = 0;
                var pointY = - height/2;

                context.moveTo(pointX, pointY);

                pointX = width/2;
                pointY = height/2;

                context.lineTo(pointX, pointY);

                pointX = -width/2;
                pointY = height/2;

                context.lineTo(pointX, pointY);

                pointX = 0;
                pointY = - height/2;

                context.lineTo(pointX, pointY);
                break;
            }
            case shapeTypes.STAR: {
                var points = [];
                var i;
                var point;
                const pathPoints = drawingUtils.calculateStarPoints(shape);
                var newPoint;

                for (i=0; i<pathPoints.length; i++) {
                    point = pathPoints[i];

                    newPoint = {};
                    newPoint.x = - width / 2 + this.transformToLocalCoordinates(point.x);
                    newPoint.y = - height / 2 + this.transformToLocalCoordinates(point.y);

                    points.push(newPoint);
                }

                context.moveTo(points[0].x, points[0].y);

                for (i=1; i<points.length; i++) {
                    context.lineTo(points[i].x, points[i].y);
                }

                context.lineTo(points[0].x, points[0].y);
                break;
            }
            case shapeTypes.HEART: {
                if (CanvasRenderingContext2D.prototype.ellipse != undefined)
                    context.ellipse(0, 0, width/2, height/2, 0, 0, 2 * Math.PI);
                break;
            }
        }

        if (shape.fillOpacity > 0) {
            context.fillStyle = this.transformRGBtoRGBA(shape.fill, shape.opacity);
            context.fill();
        }

        if (shape.strokeOpacity > 0) {
            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
            context.stroke();
        }
    },
    drawImage(shape) {
        this.resetTransform();

        const context = this.context;
        context.beginPath();

        const self = this;

        // load image from data url
        var imageObj = new Image();

        imageObj.onload = function(e) {
            const shapeCenterX = self.transformToLocalCoordinates(shape.x + shape.width / 2);
            const shapeCenterY = self.transformToLocalCoordinates(shape.y + shape.height / 2);
            const width = self.transformToLocalCoordinates(shape.width);
            const height = self.transformToLocalCoordinates(shape.height);

            if (shape.hotSpot != undefined && shape.hotSpot != '') {
                var hotspot = shape.hotSpot;
                var imgWidth = e.target.width;
                var imgHeight = e.target.height;

                context.drawImage(this, hotspot.x1 * imgWidth / 100, hotspot.y1 * imgHeight / 100,(hotspot.x2 - hotspot.x1) * imgWidth / 100, (hotspot.y2 - hotspot.y1) * imgHeight / 100, shapeCenterX - width / 2, shapeCenterY - height / 2, width, height);
            } else {
                if (shape.rotation > 0) {
                    context.translate(shapeCenterX, shapeCenterY);
                    context.rotate(self.degreesToRadians(shape.rotation));

                    context.drawImage(this, -width / 2, -height / 2, width, height);
                } else {
                    if (shape.horizontalFlip == -1 && shape.verticalFlip == -1) {
                        context.translate(shapeCenterX, shapeCenterY);
                        context.scale(-1, -1);

                        context.drawImage(this, -width / 2, -height / 2, width, height);
                    } else if (shape.horizontalFlip == -1) {
                        context.translate(shapeCenterX, shapeCenterY);
                        context.scale(-1, 1);

                        context.drawImage(this, -width / 2, -height / 2, width, height);
                    } else if (shape.verticalFlip == -1) {
                        context.translate(shapeCenterX, shapeCenterY);
                        context.scale(1, -1);

                        context.drawImage(this, -width / 2, -height / 2, width, height);
                    } else {
                        context.drawImage(this, shapeCenterX - width / 2, shapeCenterY - height / 2, width, height);
                    }
                }
            }

            self.loadCurrentAsset = false;
            self.currentIndex = self.currentIndex + 1;

            self.parseShapes();
        };

        imageObj.onerror = function() {
            self.loadCurrentAsset = false;
            self.currentIndex = self.currentIndex + 1;
            console.log('ErrorLoadinImage');

            self.parseShapes();
        };

        this.loadCurrentAsset = true;

        if (!configuration.LOAD_LOCAL && this.isProductionThumb) {
            imageObj.setAttribute('crossOrigin', 'anonymous');

            var mediaSource = this.getCorrectMediaSource(shape.xlinkHref);

            if (mediaSource.length > 0)
                imageObj.src = videoUtils.checkCacheBreaker(mediaSource);
            else
                imageObj.src = this.checkBucket(videoUtils.checkCacheBreaker(shape.xlinkHref));
        } else {
            imageObj.src = videoUtils.checkCacheBreaker(shape.xlinkHref);
        }
    },
    drawLineCurve(shape) {
        const context = this.context;
        const x1 = this.transformToLocalCoordinates(shape.x1);
        const y1 = this.transformToLocalCoordinates(shape.y1);
        const x2 = this.transformToLocalCoordinates(shape.x2);
        const y2 = this.transformToLocalCoordinates(shape.y2);

        context.beginPath();
        context.moveTo(x1, y1);

        if (shape.type == shapeTypes.CURVE) {
            const cx = this.transformToLocalCoordinates(shape.cx);
            const cy = this.transformToLocalCoordinates(shape.cy);

            context.quadraticCurveTo(cx, cy, x2, y2);
        } else {
            context.lineTo(x2, y2);
        }

        if (shape.strokeOpacity > 0) {
            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
        }

        context.stroke();
    },
    drawFreehand(shape) {
        const context = this.context;
        const shapeCenterX = this.transformToLocalCoordinates(shape.x + shape.width / 2);
        const shapeCenterY = this.transformToLocalCoordinates(shape.y + shape.height / 2);
        const width = this.transformToLocalCoordinates(shape.width);
        const height = this.transformToLocalCoordinates(shape.height);

        context.beginPath();
        context.translate(shapeCenterX, shapeCenterY);

        if (shape.rotation > 0) {
            context.rotate(this.degreesToRadians(shape.rotation));
        }

        var points = [];
        var i;
        var point;
        const pathPoints = shape.pathPoints;
        var newPoint;

        for (i=0; i<pathPoints.length; i++) {
            point = pathPoints[i];

            newPoint = {};
            newPoint.x = - width / 2 + this.transformToLocalCoordinates(point.x);
            newPoint.y = - height / 2 + this.transformToLocalCoordinates(point.y);

            points.push(newPoint);
        }

        context.moveTo(points[0].x, points[0].y);

        for (i=1; i<points.length; i++) {
            context.lineTo(points[i].x, points[i].y);
        }

        if (shape.strokeOpacity > 0) {
            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
        }

        context.stroke();
    },
    drawText(shape) {
        const context = this.context;
        const x = this.transformToLocalCoordinates(shape.x);
        const y = this.transformToLocalCoordinates(shape.y);
        const width = this.transformToLocalCoordinates(shape.width);
        const height = this.transformToLocalCoordinates(shape.height);
        const offset = this.transformToLocalCoordinates(20);

        context.beginPath();

        context.moveTo(x+offset, y);
        context.lineTo(x + width - 2 * offset, y);
        context.quadraticCurveTo(x + width, y, x + width, y + offset);
        context.lineTo(x + width, y + height - 2 * offset);
        context.quadraticCurveTo(x + width, y + height, x + width - offset, y + height);
        context.lineTo(x + offset, y + height);
        context.quadraticCurveTo(x, y + height, x, y + height - offset);
        context.lineTo(x, y + offset);
        context.quadraticCurveTo(x, y, x + offset, y);

        if (shape.fillOpacity > 0) {
            context.fillStyle = this.transformRGBtoRGBA(shape.fill, shape.opacity);
            context.fill();
        }

        if (shape.strokeOpacity > 0) {
            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
            context.stroke();
        }

        // draw Text
        var font = shape.fontSize - 5;

        if (font < 1)
            font = 1;

        var leftOffset = this.transformToLocalCoordinates(10);

        context.font = this.transformToLocalCoordinates(font) + 'px' + ' ' + shape.fontFamily;
        context.fillStyle = this.transformRGBtoRGBA(shape.fontColor, shape.opacity);
        context.fillText(shape.htmlText, x + leftOffset, y + this.transformToLocalCoordinates(30), width - 2 * leftOffset);
    },
    checkImageAspectRatio(shapeModel, dispatch, isMood = false) {
        if (!this.checkImageOriginalSize) {
            dispatch(updateImageSize(shapeModel.uuid, shapeModel.width, shapeModel.height));
            return;
        }

        var imageObj = new Image();

        imageObj.onload = function (e) {
            var target = e.target;

            if (shapeModel.mindMapProperty) { // insert a mindMap node
                let xCenter = shapeModel.x + shapeModel.width / 2;
                let yCenter = shapeModel.y + shapeModel.height / 2;
                let newWidth;
                let newHeight;

                if (target.width > target.height) {
                    newWidth = configuration.CANVAS_WIDTH / 8;
                    newHeight = newWidth * (target.height / target.width);
                } else {
                    newHeight = configuration.CANVAS_HEIGHT / 5;
                    newWidth = newHeight * (target.width / target.height);
                }

                dispatch(updateImageSize(shapeModel.uuid, newWidth, newHeight));
                dispatch(updateShapePosition(shapeModel.uuid, xCenter - newWidth / 2, yCenter - newHeight / 2));
            } else {
                if (isMood)
                    dispatch(updateImageSizeWhenChangeMood(shapeModel.uuid, target.width, target.height));
                else {
                    if (target.height > 400)
                        dispatch(updateImageSize(shapeModel.uuid, 300 * target.width / target.height, 300));
                    else if (target.width > 600)
                        dispatch(updateImageSize(shapeModel.uuid, 300, 300 * target.height / target.width));
                    else
                        dispatch(updateImageSize(shapeModel.uuid, target.width, target.height));
                }
            }
        };

        imageObj.src = videoUtils.checkCacheBreaker(shapeModel.xlinkHref);
    },
    drawVideoTimeline(canvas) {
        var context = canvas.getContext('2d');
        var elementWidth = canvas.height * 16 / 9;
        var video = document.getElementById('videoBackground');
        var length = Math.floor(canvas.width / elementWidth);
        var i;

        for (i=0; i<length; i++) {
            context.drawImage(video, i * elementWidth, 0, elementWidth, canvas.height);
        }

        context.drawImage(video, length * elementWidth, 0, canvas.width - length * elementWidth, canvas.height);
    }
};

export default thumbnailGenerator;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ThumbnailGenerator.js
 **/